<template>
  <UIInputAutocomplete
    v-model="modelValue"
    :data-refid
    :data
    :disabled
    :error
    :label
    :silent
    :size
    popper-class="transaction-form-type__popper"
    placeholder="Find an option"
  >
    <template v-if="hasPremiumTypes" #after>
      <UpgradePlan
        text="Some transaction types are exclusive to the next plan."
        class="py-2"
      />
    </template>
  </UIInputAutocomplete>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { TransactionClass } from '..'
import { InputSize } from '@types'

import { TRANSACTION_FIELD } from '../utils/const'

import { useTransactionsSettingsStore } from '@/store/transactions/settings'

import UpgradePlan from '@/modules/UpgradePlan/UpgradePlan.vue'

import { UIInputAutocomplete } from '@ui/fields'

type Props = {
  dataRefid?: string
  instance: TransactionClass
  label?: string
  size?: InputSize
  disabled?: boolean
  restrictions?: string[]
}

const props = defineProps<Props>()

const transactionsSettingsStore = useTransactionsSettingsStore()

const modelValue = props.instance.field<string>(TRANSACTION_FIELD.TYPE)

const isSavedTransaction = inject('isSavedTransaction', ref(false))

const error = computed(() => props.instance.errors.type)
const silent = computed(() => !isSavedTransaction.value)

const data = computed(() => {
  let list = transactionsSettingsStore.getTypes
  if (props.restrictions) {
    list = list.filter(item => props.restrictions?.includes(item.value))
  }
  return list
    .filter(item => !item.readonly)
    .map(item => ({
      value: item.value,
      label: item.value,
    }))
})

const hasPremiumTypes = computed(() => {
  return transactionsSettingsStore.getTypes.some(item => item.readonly)
})
</script>

<style>
.transaction-form-type {
  &__popper {
    .v-popper__inner {
      @apply min-w-44;
    }
  }
}
</style>
